import { render } from "./BillDetails.vue?vue&type=template&id=3a702164&scoped=true"
import script from "./BillDetails.vue?vue&type=script&lang=js"
export * from "./BillDetails.vue?vue&type=script&lang=js"

import "./BillDetails.vue?vue&type=style&index=0&id=3a702164&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a702164"]])

export default __exports__